import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormRevokingConsent } from "../Models/Forms/IFormRevokingConsent";

@Injectable()
export class FormRevokingConsentService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormRevokingConsent(id: number) {
    return this._http.get(this._baseUrl + "api/FormRevokingConsent/" + id)
      .map((response: IFormRevokingConsent) => response as IFormRevokingConsent)
      .catch(this.errorHandler);
  }


  getMostRecentFormRevokingConsent(localStudentId: string) {
    return this._http.get(this._baseUrl + "api/FormRevokingConsent/GetMostRecentFormRevokingConsent/" + localStudentId)
      .map((response: IFormRevokingConsent) => response as IFormRevokingConsent)
      .catch(this.errorHandler);
  }

  insertUpdateFormRevokingConsent(formRevokingConsentDetails: IFormRevokingConsent) {
    return this._http.post(this._baseUrl + 'api/FormRevokingConsent', formRevokingConsentDetails)
      .map((response: IFormRevokingConsent) => response as IFormRevokingConsent)
      .catch(this.errorHandler);
  }

  deleteRevokingConsent(id) {
    return this._http.delete(this._baseUrl + "api/FormRevokingConsent" + id)
      .map((response: IFormRevokingConsent) => response as IFormRevokingConsent)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}



